export const fontFamily = {
    regular: '"JohnsonText-Regular"',
    light: '"J&J CircularTT Light Web"'
};
  